import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import Table from '../../../../../../../../../../components/Table'
import ImagesPreviewModal from '../../../../../../../../../../features/components/Modals/ImagesPreviewModal'

import { AddProductsBulkContext } from '../../../AddProductsBulkContext'
import { MediaOrderFormContext } from '../../../../../../../MediaOrderFormContext'

import useReachData from '../../../../../ProductsTable/useReachData'
import usePreviewProductColumns from './cols/usePreviewProductColumns'
import { useProductImagesPreviewModal } from '../../../../../../../../../../features/components/ProductsSelectionList/ProductImagesPreviewModal/useProductImagesPreviewModal'

import { isProductValid } from './helpers'

import { MEDIA_PRODUCTS } from '../../../../../../fields'

import useStyles from '../../../../../ProductsTable/styles'

export const QUOTATION_BUILDER_TABLE_ID = 'quotation-builder-table'

const AddProductBulkTableData = ({ formik }) => {
  const classes = useStyles()
  const { values, setFieldValue } = formik

  const { hideUnavailable } = useContext(AddProductsBulkContext)

  const products = values[MEDIA_PRODUCTS]
  const visibleProducts = useMemo(() => {
    // hide invalid products
    return hideUnavailable ? products.filter(product => isProductValid(product)) : products
  }, [hideUnavailable, products])
  const productsDataList = useMemo(() => visibleProducts.map(product => product.data), [visibleProducts])

  const {
    // contextSelfAccountData,
    currency
  } = useContext(MediaOrderFormContext)
  const currencySymbol = currency?.symbol

  const { hasReachData } = useReachData({ selectedProducts: visibleProducts, setFieldValue })

  const validProductsIds = useMemo(() => {
    return visibleProducts.reduce((acc, productValues) => {
      const isValid = isProductValid(productValues)

      if (isValid) {
        acc.push(productValues.id)
      }
      return acc
    }, [])
  }, [visibleProducts])

  const {
    showModal: showProductImagesModal,
    selectedProduct,
    formattedProductImages,
    selectedImageId,
    openModal: openProductImagesModal,
    closeModal: closeProductImagesModal,
    handleSelectImage
  } = useProductImagesPreviewModal(productsDataList)

  const productPreviewColumns = usePreviewProductColumns({
    classes,
    hasReachData,
    currencySymbol,
    validProductsIds,
    openProductImagesModal
  })

  return (
    <>
      <Table
        className={classes.quotationsProductsTable}
        cols={productPreviewColumns}
        data={visibleProducts}
        enableSorting={true}
        tableId={QUOTATION_BUILDER_TABLE_ID}
        hideFooterRow={true}
      />
      <ImagesPreviewModal
        title={selectedProduct.name}
        images={formattedProductImages}
        showModal={showProductImagesModal}
        onModalClose={closeProductImagesModal}
        selectedImageId={selectedImageId}
        handleSelectImage={handleSelectImage}
      />
    </>
  )
}

AddProductBulkTableData.propTypes = {
  formik: PropTypes.object
}

export default AddProductBulkTableData
